
<div class="  " style="position: relative; "         id="myModal">
    <div>
        <div 
        style="
        position: relative;
        top: 25px;
        left: 14px;
        z-index: 22;
        display: flex;
        justify-content: flex-end;
        ">
            <button type="button" class="p-0"  (click)="CloseModal()" ><img src="assets/images/colse..png"></button>
        </div>
        <img src="../../../../assets/images/backimg.png" style="
            width: 498px;
            gap: 0px;
            opacity: 0px;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            ">
    </div>
    <div class="">
        <img class="w-100 px-1" [src]="greetingData?.flatData?.greetingImage[0]?.url" style=" position: relative; z-index: 1;
        top: 30px;
        left: 0;
        border-radius: 4px 0px 0px 0px;
        height: 300px;
        ">
    </div>

    <h3 class="pt-5" style="
    font-weight: 600;
    line-height: 30.35px;
    padding-right: 14px;
    ">{{greetingData?.flatData?.greetingTitle}}</h3>
    <p class="p-3 " style="
font-size: 14px;
font-weight: 400;
line-height: 18.66px;
"
[innerHTML]="greetingData?.flatData?.greetingText"
>
</p>
</div>